import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

// Custom hook to redirect authenticated users to a specified path
export const useRedirectIfAuthenticated = (user, redirectPath) => {
  const navigate = useNavigate();

  useEffect(() => {
    if (user) {
      navigate(redirectPath, { replace: true });
    }
  }, [user, navigate, redirectPath]);
};
